import router from "@/router";
import { Toast } from "vant";

// 云手机图标资源集，可按场景传入不同 type 复用
// default：云手机列表/控制台；yaoqing：邀请页
const CLOUD_ICON_ASSETS = {
    default: {
        // 自定义VIP图标是否必须为 http 开头
        requireHttp: true,
        defaultIcon: require("@/assets/icons/dingzhianzhuo.png"),
        iconMap: {
            VIP1: {
                V8: require("@/assets/icons/biaozhunanzhuo8.png"),
                V10: require("@/assets/icons/biaozhunanzhuo10.png"),
                V11: require("@/assets/icons/biaozhunanzhuo11.png"),
                V12: require("@/assets/icons/biaozhunanzhuo12.png"),
                V15: require("@/assets/icons/biaozhunanzhuo15.png"),
            },
            VIP2: {
                V8: require("@/assets/icons/changwananzhuo8.png"),
                V10: require("@/assets/icons/changwananzhuo10.png"),
                V12: require("@/assets/icons/changwananzhuo12.png"),
                V15: require("@/assets/icons/changwananzhuo15.png"),
            },
            VIP3: {
                V8: require("@/assets/icons/aorananzhuo8.png"),
                V10: require("@/assets/icons/aorananzhuo10.png"),
                V12: require("@/assets/icons/aorananzhuo12.png"),
            },
            VIP4: {
                V8: require("@/assets/icons/zhizunanzhuo8.png"),
                V10: require("@/assets/icons/zhizunanzhuo10.png"),
                V12: require("@/assets/icons/zhizunanzhuo12.png"),
            },
        },
    },
    yaoqing: {
        requireHttp: false,
        defaultIcon: require("@/assets/img/yongjin/dingzhi.png"),
        iconMap: {
            VIP1: {
                V8: require("@/assets/img/yaoqing/biaozhun8.png"),
                V10: require("@/assets/img/yaoqing/biaozhun10.png"),
                V11: require("@/assets/img/yaoqing/biaozhun11.png"),
                V12: require("@/assets/img/yaoqing/biaozhun12.png"),
                V15: require("@/assets/img/yaoqing/biaozhun15.png"),
            },
            VIP2: {
                V8: require("@/assets/img/yaoqing/changwan8.png"),
                V10: require("@/assets/img/yaoqing/changwan10.png"),
                V12: require("@/assets/img/yaoqing/changwan12.png"),
                V15: require("@/assets/img/yaoqing/changwan15.png"),
            },
            VIP3: {
                V8: require("@/assets/img/yaoqing/aoran8.png"),
                V10: require("@/assets/img/yaoqing/aoran10.png"),
                V12: require("@/assets/img/yaoqing/aoran12.png"),
            },
            VIP4: {
                V8: require("@/assets/img/yaoqing/zhizun8.png"),
                V10: require("@/assets/img/yaoqing/zhizun10.png"),
                V12: require("@/assets/img/yaoqing/zhizun12.png"),
            },
        },
    },
};

export default {
    // 倒计时函数，作废
    countTime(endTime) {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var endDate = new Date(endTime);
        var end = endDate.getTime();
        //时间差
        var leftTime = end - now;
        //定义变量 d,h,m,s保存倒计时的时间
        let d = ''
        let h = ''
        let m = ''
        let s = ''
        if (leftTime >= 0) {
            d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
            h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
            m = Math.floor((leftTime / 1000 / 60) % 60);
            s = Math.floor((leftTime / 1000) % 60);
        }
        setTimeout(this.countTime, 1000);
        return `${d}天${h}小时${m}分钟`
        //递归每秒调用countTime方法，显示动态时间效果

    },
    isAppleWebKit() {
        var userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf('applewebkit') !== -1 &&
            userAgent.indexOf('chrome') === -1 &&
            userAgent.indexOf('chromium') === -1 &&
            userAgent.indexOf('crios') === -1 &&
            userAgent.indexOf('fxios') === -1 &&
            userAgent.indexOf('safari') === -1;
    },

    // 当前时间转换为字符串格式日期
    getCurrentTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 字符串日期转换为日期对象
    convertToDateObject(dateString) {
        // 解析日期字符串，确保月份和分钟不会被误解为8进制
        var dateParts = dateString.split(/[- :]/);
        // 获取年、月、日、小时、分钟、秒
        var year = dateParts[0];
        var month = dateParts[1] - 1; // 月份是从0开始的，所以要减1
        var day = dateParts[2];
        var hour = dateParts[3];
        var minute = dateParts[4];
        var second = dateParts[5];

        // 使用UTC时间创建新的日期对象
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    },
    // 复制方法
    commonCopy(value, msg) {
        var aux = document.createElement("input");
        aux.setAttribute("value", value);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        if (msg) {
            Toast(msg);
        }
    },
    // 设备信息
    deviceInfo() {
        let webLog = {};
        let userAgent = navigator.userAgent; // 获取微信版本
        let m1 = userAgent.match(/MicroMessenger.*?(?= )/);
        if (m1 && m1.length > 0) {
            webLog.wechat = m1[0];
        } // 苹果手机
        if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
            // 获取设备名
            if (userAgent.includes("iPad")) {
                webLog.device = "iPad";
            } else {
                webLog.device = "iPhone";
            } // 获取操作系统版本
            m1 = userAgent.match(/iPhone OS .*?(?= )/);
            if (m1 && m1.length > 0) {
                webLog.system = m1[0];
            }
        } // 安卓手机
        if (userAgent.includes("Android")) {
            // 获取设备名
            m1 = userAgent.match(/Android.*; ?(.*(?= Build))/);
            if (m1 && m1.length > 1) {
                webLog.device = m1[1];
            } // 获取操作系统版本
            m1 = userAgent.match(/Android.*?(?=;)/);
            if (m1 && m1.length > 0) {
                webLog.system = m1[0];
            }
        }
        return webLog
    },
    // 获取云手机图标路径（type: default-默认图标集 | yaoqing-邀请页图标集）
    getCloudIcon(item, type = "default") {
        const { iconMap, defaultIcon, requireHttp } =
            CLOUD_ICON_ASSETS[type] || CLOUD_ICON_ASSETS.default;
        if (!item) return defaultIcon;
        const { vipCode, deviceVersionCode, iconUrl } = item;
        const isCustomVip = !["VIP1", "VIP2", "VIP3", "VIP4"].includes(
            vipCode
        );
        // 自定义VIP且有自己的图标
        if (isCustomVip && iconUrl) {
            return !requireHttp || iconUrl.startsWith("http")
                ? iconUrl
                : defaultIcon;
        }
        // 返回对应图标，如果没有匹配则返回默认图标
        return (
            (iconMap[vipCode] && iconMap[vipCode][deviceVersionCode]) ||
            defaultIcon
        );
    },
    // 判断是否使用自定义图标盒子样式
    isCustomCloudIcon(item) {
        if (!item) return false;
        const isCustomVip = !["VIP1", "VIP2", "VIP3", "VIP4"].includes(
            item.vipCode
        );
        return isCustomVip && item.iconUrl && item.iconUrl.startsWith("http");
    },
    // 手动实现银行家舍入（避免toFixed的精度问题）
    bankerRound(num, decimals = 2) {
        const factor = Math.pow(10, decimals);
        const rounded = Math.round(num * factor * 10) / 10; // 多保留一位避免误差
        const adjusted = Math.abs(rounded % 1) === 0.5 ?
            (Math.floor(rounded) % 2 === 0 ? Math.floor(rounded) : Math.ceil(rounded)) :
            Math.round(rounded);
        return adjusted / factor;
    },
    // 复制方法
    copy(value, toast) {
        var aux = document.createElement("input");
        aux.setAttribute("value", value);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        if (toast) {
            Toast(toast);
        }
    },
}
// 只能是数字，并保留两位小数，且整数部分开头不能为0
export function limitFloat(val) {
    let sNum = val.toString(); //先转换成字符串类型
    if (sNum.indexOf('.') == 0) {//第一位就是 .
        console.log('first str is .')
        sNum = '0' + sNum
    }
    sNum = sNum.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
    sNum = sNum.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    sNum = sNum.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    sNum = sNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    if (sNum.indexOf(".") < 0 && sNum != "") {
        sNum = parseFloat(sNum);
    }
    return sNum
}

